module.exports = __webpack_public_path__ + "img/ic_viewpay.22417a2d.svg";